import styles from './index.module.scss'

export function getUserChatBubbleLayoutClasses(bubbleAlign, hasReactions) {
  const bubbleWithReactionsClassName =
    bubbleAlign === 'start'
      ? `${styles.bubbleWithReactions} ${styles.bubbleWithReactionsStart}${hasReactions ? ` ${styles.bubbleWithReactionsHasReactions}` : ''}`
      : `${styles.bubbleWithReactions}${hasReactions ? ` ${styles.bubbleWithReactionsHasReactions}` : ''}`
  const bubbleAnchorClassName =
    bubbleAlign === 'start'
      ? `${styles.bubbleHoverAnchor} ${styles.bubbleHoverAnchorStart}`
      : styles.bubbleHoverAnchor
  const wrapClassName = bubbleAlign === 'start' ? `${styles.wrap} ${styles.wrapStart}` : styles.wrap
  const toolbarPlacement = bubbleAlign === 'start' ? 'top-start' : 'top-end'
  return { bubbleWithReactionsClassName, bubbleAnchorClassName, wrapClassName, toolbarPlacement }
}
